import { bindMethod } from 'helpers/bind';
import InternalPage from 'navigation/pages/InternalPage';
import ProfileForm from './partials/ProfileForm';
class Profile extends InternalPage {
    getModulesMap() {
        return {
            form: ['.profile__form', ProfileForm]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            pageManager: this.parent.modules.content
        };
    }
    bindEvents(add = true) {
        super.bindEvents();
        const method = bindMethod(add);
        this.refs.editProfile[method]('click', this.editProfile);
    }
    editProfile = (e) => {
        e.preventDefault();
        this.modules.form.toggle(true);
        this.refs.accountItem.classList.toggle('hidden');
    };
    bindModules() {
        super.bindModules();
    }
}
export default Profile;
